
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { LoadingBar } from '../Layout/LoadingBar';

interface FullPageLoaderProps {
  isLoading: boolean;
  icon: LucideIcon;
  text?: string;
  theme?: 'light' | 'dark';
}

export const FullPageLoader: React.FC<FullPageLoaderProps> = ({ isLoading, icon: Icon, text, theme = 'light' }) => {
  if (!isLoading) return null;

  const bgClass = theme === 'dark' ? 'bg-black text-white' : 'bg-white text-gray-900';
  const ringColor = theme === 'dark' ? 'border-gray-800 border-t-rose-500' : 'border-gray-100 border-t-rose-500';
  const innerBg = theme === 'dark' ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-50';

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center relative ${bgClass} z-50`}>
        <LoadingBar isLoading={true} />
        
        <div className="relative flex flex-col items-center animate-in fade-in zoom-in duration-300">
            {/* Animated Icon Container */}
            <div className="relative w-24 h-24 flex items-center justify-center mb-6">
                {/* Outer Spinning Ring */}
                <div className={`absolute inset-0 border-[6px] ${ringColor} rounded-full animate-spin`}></div>
                
                {/* Inner Pulsing Circle */}
                <div className={`absolute inset-3 border-2 rounded-full shadow-sm flex items-center justify-center ${innerBg}`}>
                     <Icon size={28} className="text-rose-500 animate-pulse" strokeWidth={2.5} />
                </div>
            </div>
            {text && (
                <p className={`text-sm font-medium tracking-wide animate-pulse ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                    {text}
                </p>
            )}
        </div>
    </div>
  );
};
